/* Raw Performance — product page behaviour (rp-product-* sections)
   - size cards drive Turbo's own variant dropdown
   - prices follow the selected size and the Recharge subscription choice
   - feeding estimate + feeding guide
   - sticky add-to-cart bar on phones
   - "Add to the bowl" quick add
   No dependencies. Safe to load more than once. */
(function () {
  'use strict';

  if (window.RPProduct) { window.RPProduct.initAll(); return; }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(Math.round(cents), format); } catch (e) { /* fall through */ }
    }
    var value = (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function round(n, dp) {
    var f = Math.pow(10, dp);
    return Math.round(n * f) / f;
  }

  function fmtLb(n) {
    if (n >= 10) return String(round(n, 0));
    return String(round(n, 2));
  }

  // Amount in the chosen unit (lb / oz / g), number only.
  function fmtAmount(lb, unit) {
    if (unit === 'oz') { var oz = lb * 16; return String(oz >= 10 ? Math.round(oz) : round(oz, 1)); }
    if (unit === 'g') return String(Math.round(lb * 453.592));
    return fmtLb(lb);
  }

  // Share of the day's food this product makes up (100 = the whole meal).
  function shareOf(n) {
    n = Number(n);
    return n > 0 && n <= 100 ? n : 100;
  }

  function fmtDays(days) {
    if (!isFinite(days) || days <= 0) return '';
    if (days < 1) return 'under a day';
    if (days < 1.5) return 'about a day';
    var half = Math.round(days * 2) / 2;
    var txt = String(half).replace('.5', '½');
    return 'about ' + txt + ' days';
  }

  function fill(template, map) {
    return String(template || '').replace(/\[(\w+)\]/g, function (m, key) {
      return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : m;
    });
  }

  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ------------------------------------------------------------------ */
  /* Shared state: one per page, owned by the main section               */
  /* ------------------------------------------------------------------ */

  var state = {
    data: null,
    form: null,
    variantId: null,
    planId: null,
    listeners: []
  };

  function onChange(fn) { state.listeners.push(fn); }

  function emit() {
    var v = currentVariant();
    var price = currentPrice();
    state.listeners.forEach(function (fn) {
      try { fn(v, price); } catch (e) { /* keep going */ }
    });
    document.dispatchEvent(new CustomEvent('rp:product:change', { detail: { variant: v, price: price, sellingPlan: state.planId } }));
  }

  function variantById(id) {
    if (!state.data) return null;
    id = Number(id);
    for (var i = 0; i < state.data.variants.length; i++) {
      if (state.data.variants[i].id === id) return state.data.variants[i];
    }
    return null;
  }

  function currentVariant() {
    return variantById(state.variantId) || (state.data && state.data.variants[0]) || null;
  }

  function priceFor(v) {
    if (!v) return 0;
    if (state.planId && v.plans && Object.prototype.hasOwnProperty.call(v.plans, state.planId)) {
      return v.plans[state.planId];
    }
    return v.price;
  }

  function currentPrice() { return priceFor(currentVariant()); }

  function readForm() {
    var form = state.form;
    if (!form) return;
    var idField = form.querySelector('[name="id"]');
    if (idField && idField.value) state.variantId = Number(idField.value);

    // Recharge (and Shopify's own selling-plan UI) submit the plan as selling_plan.
    var plan = null;
    var planFields = form.querySelectorAll('[name="selling_plan"]');
    for (var i = 0; i < planFields.length; i++) {
      var f = planFields[i];
      if (f.disabled) continue;
      if ((f.type === 'radio' || f.type === 'checkbox') && !f.checked) continue;
      if (f.value) { plan = String(f.value); break; }
    }
    // Recharge's legacy widget: a subscribe radio plus a plan dropdown.
    if (!plan) {
      var subsave = form.querySelector('.rc_widget__option__input--subsave, input[value="subsave"]');
      if (subsave && subsave.checked) {
        var dd = form.querySelector('.rc-selling-plans__dropdown, .rc_widget__option__plans__dropdown');
        if (dd && dd.value) plan = String(dd.value);
      }
    }
    // Only trust ids that belong to this product's plans.
    if (plan) {
      var known = false;
      (state.data.variants || []).forEach(function (v) {
        if (v.plans && Object.prototype.hasOwnProperty.call(v.plans, plan)) known = true;
      });
      if (!known) plan = null;
    }
    state.planId = plan;
  }

  var refreshQueued = false;
  function refresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(function () {
      refreshQueued = false;
      var before = state.variantId + '|' + state.planId;
      readForm();
      var after = state.variantId + '|' + state.planId;
      if (before !== after || !state.ready) {
        state.ready = true;
        emit();
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Main section                                                        */
  /* ------------------------------------------------------------------ */

  function initMain(root) {
    if (root.__rpInit) return;
    root.__rpInit = true;

    state.data = readJSON(root.querySelector('[data-rp-product-json]'));
    if (!state.data) return;
    state.form = root.querySelector('.product_form form, form[action*="/cart/add"]');
    readForm();

    // Size cards → Turbo's dropdown
    var group = root.querySelector('[data-rp-sizes]');
    if (group) {
      var cards = Array.prototype.slice.call(group.querySelectorAll('.rp-size'));

      var select = function (card, focus) {
        if (card.getAttribute('aria-disabled') === 'true') return;
        cards.forEach(function (c) {
          var on = c === card;
          c.setAttribute('aria-checked', on ? 'true' : 'false');
          c.tabIndex = on ? 0 : -1;
        });
        if (focus) card.focus();

        var value = card.getAttribute('data-option-value');
        var id = card.getAttribute('data-variant-id');
        var optionSelect = root.querySelector('.product_form .single-option-selector');
        if (optionSelect && window.jQuery) {
          optionSelect.value = value;
          window.jQuery(optionSelect).trigger('change');
        } else if (optionSelect) {
          optionSelect.value = value;
          if (typeof optionSelect.onchange === 'function') optionSelect.onchange({});
          optionSelect.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          // Turbo's script hasn't replaced the select yet — set the id directly.
          var raw = root.querySelector('.product_form select[name="id"]');
          if (raw) {
            raw.value = id;
            raw.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        refresh();
      };

      cards.forEach(function (card, i) {
        card.addEventListener('click', function () { select(card, false); });
        card.addEventListener('keydown', function (e) {
          var dir = 0;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
          if (!dir) return;
          e.preventDefault();
          var n = cards.length;
          for (var k = 1; k <= n; k++) {
            var next = cards[(i + dir * k + n * k) % n];
            if (next.getAttribute('aria-disabled') !== 'true') { select(next, true); break; }
          }
        });
      });

      // Keep cards in step if the variant changes some other way (URL, back button).
      onChange(function (v) {
        if (!v) return;
        cards.forEach(function (c) {
          var on = Number(c.getAttribute('data-variant-id')) === v.id;
          c.setAttribute('aria-checked', on ? 'true' : 'false');
          c.tabIndex = on ? 0 : -1;
        });
      });

      // Per-lb figures follow the subscription choice.
      onChange(function () {
        cards.forEach(function (c) {
          var v = variantById(c.getAttribute('data-variant-id'));
          var meta = c.querySelector('[data-rp-size-meta]');
          if (!v || !meta || !v.available) return;
          var p = priceFor(v);
          if (state.data.showPerLb && v.lbs > 0) {
            meta.textContent = formatMoney(p / v.lbs, state.data.moneyFormat) + ' / lb';
          } else {
            meta.textContent = formatMoney(p, state.data.moneyFormat);
          }
        });
      });
    }

    // Price inside the add-to-cart button
    var atc = root.querySelector('.product_form .add_to_cart');
    if (atc) {
      var slot = document.createElement('em'); // not a <span>: Turbo rewrites every span in the button
      slot.className = 'rp-atc-price';
      atc.appendChild(slot);
      onChange(function (v, price) {
        slot.textContent = v && v.available ? formatMoney(price, state.data.moneyFormat) : '';
      });
    }

    // Feeding estimate
    var est = root.querySelector('[data-rp-estimate]');
    if (est && state.data.estimate) {
      var cfg = state.data.estimate;
      var textEl = est.querySelector('[data-rp-estimate-text]');
      var link = est.querySelector('a[href="#rp-feeding"]');
      if (link && !document.getElementById('rp-feeding')) link.remove();
      onChange(function (v) {
        var meal = cfg.weight * cfg.rate / 100;
        var share = shareOf(cfg.share);
        var daily = meal * share / 100;
        var map = {
          weight: String(cfg.weight),
          dog: cfg.dog || 'dog',
          daily: fmtAmount(daily, cfg.unit),
          share: String(share),
          meal: fmtLb(meal),
          rest: fmtLb(meal - daily),
          size: v && v.lbs > 0 ? (v.lbs + ' lb ' + (v.lbs >= 10 ? 'case' : 'tub')) : '',
          days: v && v.lbs > 0 ? fmtDays(v.lbs / daily) : ''
        };
        var tpl = v && v.lbs > 0 ? cfg.template : cfg.templateNoLbs;
        if (!tpl) { est.hidden = true; return; }
        textEl.textContent = fill(tpl, map);
        est.hidden = false;
      });
    }

    // Sticky bar (phones)
    var sticky = root.querySelector('[data-rp-sticky]');
    if (sticky && atc) {
      var stickyPrice = sticky.querySelector('[data-rp-sticky-price]');
      var stickyVariant = sticky.querySelector('[data-rp-sticky-variant]');
      var stickyBtn = sticky.querySelector('[data-rp-sticky-button]');
      var multi = state.data.variants.length > 1;

      onChange(function (v, price) {
        if (!v) return;
        stickyPrice.textContent = formatMoney(price, state.data.moneyFormat);
        var label = multi ? v.title : '';
        if (state.planId) label = (label ? label + ' · ' : '') + 'subscribed';
        stickyVariant.textContent = label;
        stickyBtn.disabled = !v.available;
      });

      stickyBtn.addEventListener('click', function () {
        atc.click();
      });

      var ticking = false;
      var update = function () {
        ticking = false;
        var r = atc.getBoundingClientRect();
        var show = r.bottom < 0 && window.matchMedia('(max-width: 798px)').matches;
        if (sticky.classList.contains('is-visible') === show) return;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
      };
      var onScroll = function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }

    // Watch the form: Turbo's selector, Recharge's widget, the URL.
    if (state.form) {
      state.form.addEventListener('change', refresh);
      state.form.addEventListener('click', function () { setTimeout(refresh, 0); });
      if ('MutationObserver' in window) {
        new MutationObserver(refresh).observe(state.form, {
          subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'checked', 'disabled']
        });
      }
    }
    window.addEventListener('popstate', function () { setTimeout(refresh, 50); });
    // Recharge renders after load; poll briefly for its hidden field.
    var polls = 0;
    var poll = setInterval(function () { refresh(); if (++polls > 20) clearInterval(poll); }, 250);

    refresh();
  }

  /* ------------------------------------------------------------------ */
  /* Feeding guide                                                        */
  /* ------------------------------------------------------------------ */

  function initFeeding(root) {
    if (root.__rpInit) return;
    root.__rpInit = true;
    var cfg = readJSON(root.querySelector('[data-rp-feeding-json]'));
    if (!cfg) return;

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-rp-stage]'));
    var range = root.querySelector('[data-rp-weight]');
    var weightOut = root.querySelector('[data-rp-weight-out]');
    var out = {
      daily: root.querySelector('[data-rp-out="daily"]'),
      dailyLabel: root.querySelector('[data-rp-out="daily-label"]'),
      cost: root.querySelector('[data-rp-out="cost"]'),
      costLabel: root.querySelector('[data-rp-out="cost-label"]'),
      packs: root.querySelector('[data-rp-out="packs"]'),
      packsLabel: root.querySelector('[data-rp-out="packs-label"]'),
      rest: root.querySelector('[data-rp-out="rest"]'),
      restLabel: root.querySelector('[data-rp-out="rest-label"]')
    };
    var costTile = root.querySelector('[data-rp-tile="cost"]');
    var packsTile = root.querySelector('[data-rp-tile="packs"]');
    var stats = root.querySelector('.rp-stats');

    var stage = 0;
    chips.forEach(function (c, i) { if (c.getAttribute('aria-pressed') === 'true') stage = i; });

    // Fallback product data when the main section isn't on the page
    var ownVariant = cfg.variant || null;

    function render() {
      var w = Number(range.value);
      var rate = Number(chips[stage] ? chips[stage].getAttribute('data-rate') : cfg.rate || 2.5);
      var meal = w * rate / 100;
      var share = shareOf(cfg.share);
      var daily = meal * share / 100;
      var unit = cfg.unit || 'lb';
      var tokens = { rate: String(rate), share: String(share), meal: fmtLb(meal) };
      weightOut.textContent = w + ' lb';
      range.style.setProperty('--fill', ((w - range.min) / (range.max - range.min) * 100) + '%');
      range.setAttribute('aria-valuetext', w + ' pounds');

      out.daily.textContent = fmtAmount(daily, unit) + ' ' + unit;
      out.dailyLabel.textContent = fill(cfg.labels.daily, tokens);
      if (out.rest) {
        out.rest.textContent = fmtLb(meal - daily) + ' lb';
        out.restLabel.textContent = fill(cfg.labels.rest, tokens);
      }

      var v = state.data ? currentVariant() : ownVariant;
      var price = state.data ? currentPrice() : (ownVariant ? ownVariant.price : 0);
      var hasLbs = v && v.lbs > 0 && price > 0;

      if (costTile) costTile.hidden = !hasLbs;
      if (packsTile) packsTile.hidden = !hasLbs;
      var visible = 1 + (out.rest ? 1 : 0) + (hasLbs ? 2 : 0);
      if (stats) stats.style.setProperty('--rp-stat-cols', visible === 4 ? 2 : visible);

      if (hasLbs) {
        var perLb = price / v.lbs;
        out.cost.textContent = formatMoney(daily * perLb, cfg.moneyFormat);
        var sizeLabel = v.lbs + ' lb ' + (v.lbs >= 10 ? 'case' : 'tub');
        out.costLabel.textContent = fill(cfg.labels.cost, { size: sizeLabel, subscribed: state.planId ? cfg.labels.subscribed : '' }).replace(/\s+,/g, ',').trim();
        var perMonth = daily * 30.4;
        var packs = perMonth / v.lbs;
        if (packs < 1) {
          out.packs.textContent = fmtDays(v.lbs / daily).replace('about ', '');
          out.packsLabel.textContent = fill(cfg.labels.lasts, { size: sizeLabel });
        } else {
          out.packs.textContent = String(packs < 3 ? round(packs, 1) : Math.round(packs));
          out.packsLabel.textContent = fill(cfg.labels.packs, { size: sizeLabel });
        }
      }
    }

    chips.forEach(function (c, i) {
      c.addEventListener('click', function () {
        stage = i;
        chips.forEach(function (o, j) { o.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        render();
      });
    });
    range.addEventListener('input', render);
    onChange(render);
    render();
  }

  /* ------------------------------------------------------------------ */
  /* Add to the bowl — quick add                                          */
  /* ------------------------------------------------------------------ */

  function initPairs(root) {
    if (root.__rpInit) return;
    root.__rpInit = true;
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-rp-quick-add]');
      if (!form || !window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('button');
      var live = form.querySelector('[data-rp-live]');
      btn.disabled = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch(root + 'cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          btn.classList.add('is-added');
          if (live) live.textContent = form.getAttribute('data-added-text') || 'Added to cart';
          document.querySelectorAll('.cart_count').forEach(function (el) { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('rp:cart:updated', { detail: cart }));
          setTimeout(function () { btn.classList.remove('is-added'); if (live) live.textContent = ''; }, 2500);
        })
        .catch(function () { form.submit(); })
        .then(function () { btn.disabled = false; });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-rp-product]').forEach(initMain);
    document.querySelectorAll('[data-rp-feeding]').forEach(initFeeding);
    document.querySelectorAll('[data-rp-pairs]').forEach(initPairs);
  }

  window.RPProduct = { initAll: initAll, state: state };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function () {
    state.listeners = [];
    document.querySelectorAll('[data-rp-product],[data-rp-feeding],[data-rp-pairs]').forEach(function (el) { el.__rpInit = false; });
    state.ready = false;
    initAll();
  });
})();
